export default "__VITE_ASSET__qXMj4fI4__"